import t from "../../locales/common.json";

<style/styles: any>
  .textContainer > * + * {
    margin-block-start: 0.8em;
  }
</style>

<div>
  <container class="region grid gap2 relative" width="prose">
    <star
      size=24
      bottom="calc(var(--text-2) * 6)"
      left="calc(var(--text-2) * -6)"
    />
    <section class="grid gap5 relative">
      <star
        size=48
        variant
        top="calc(var(--text-2) * 6)"
        right="calc(var(--text-2) * -6)"
      />
      <heading-1 class="text-center font-bold">${t.cc.Legal.header}</heading-1>
      <p class="text2 font-semibold text-accent wrap-balance">
        ${t.cc.Legal.description}
      </p>
    </section>
    <rule/>
    <section class="grid gap0">
      <heading-2>${t.cc.Legal.visa.header}</heading-2>
      <p>${t.cc.Legal.visa.description}</p>
      <u-list>
        <for|item| of=t.cc.Legal.visa.items>
          <li>${item}</li>
        </for>
      </u-list>
    </section>

    <rule/>
    <section class="grid gap0">
      <heading-2>${t.cc.Legal.consulate.header}</heading-2>
      <p>${t.cc.Legal.consulate.body}</p>
    </section>

    <rule/>
    <section class="grid gap0">
      <heading-2>${t.cc.Legal.certificate.header}</heading-2>
      <div class=styles.textContainer>
        <p>${t.cc.Legal.certificate.description}</p>
        <u-list>
          <for|item| of=t.cc.Legal.certificate.items>
            <li>${item}</li>
          </for>
        </u-list>
      </div>
    </section>
    <rule/>
    <section class="grid gap0">
      <heading-2>${t.cc.Legal.citizenship}</heading-2>
    </section>
    <rule/>
    <section class="grid gap0">
      <heading-2>${t.cc.Legal.healthInsurance}</heading-2>
    </section>
    <rule/>
  </container>
</div>
